module.exports = __webpack_public_path__ + "img/备案图标.58f55c5c.png";